import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block rounded-xl overflow-hidden bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
      data-product-shop=""
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={movie.image}
          alt={movie.title}
          title={`${movie.title} - 极速影视`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
          {movie.isNew && (
            <span className="px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-[10px] font-medium whitespace-nowrap">
              最新
            </span>
          )}
          {movie.isHot && (
            <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-[10px] font-medium whitespace-nowrap">
              热播
            </span>
          )}
        </div>
        <div className="absolute top-3 right-3 px-2 py-0.5 rounded-md bg-black/60 text-background-50 text-[10px] font-medium backdrop-blur-sm whitespace-nowrap">
          <i className="ri-star-fill text-accent-500 mr-0.5"></i>
          {movie.rating}
        </div>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 text-background-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
            <i className="ri-play-fill text-xl"></i>
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate font-heading">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
          <span>{movie.year}</span>
          <span className="text-foreground-300">|</span>
          <span>{movie.subcategory}</span>
          {movie.episodes > 1 && (
            <>
              <span className="text-foreground-300">|</span>
              <span>共{movie.episodes}集</span>
            </>
          )}
        </div>
      </div>
    </Link>
  );
}